"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRfiTexts = void 0;
const Literals = __importStar(require("../constants/rfi.literals"));
const rfi_utils_1 = require("../utils/rfi.utils");
// This "hook" does not use react, consider moving it to helpers
const useRfiTexts = ({ subType, userName, translate }) => {
    return {
        title: translate(Literals.TITLE, { name: userName || '', subtype: (0, rfi_utils_1.getPoeKeyForRFISubtype)(subType, translate) }),
        cancelButton: translate(Literals.CANCEL_BUTTON),
        goToProfileButton: translate(Literals.GO_TO_PROFILE),
        contentDescription01: translate(Literals.RFI_DESCRIPTION_01),
        contentDescription02: translate(Literals.RFI_DESCRIPTION_02),
        closeButtonAltText: translate(Literals.CLOSE_BUTTON_ALT_TEXT),
    };
};
exports.useRfiTexts = useRfiTexts;
exports.default = exports.useRfiTexts;
//# sourceMappingURL=useRfiTexts.hook.js.map